var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortalPageTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3H21C21.8284 3 22.5 3.67157 22.5 4.5V6H1.5V4.5C1.5 3.67157 2.17157 3 3 3ZM24 7.5V6V4.5C24 2.84315 22.6569 1.5 21 1.5H3C1.34315 1.5 0 2.84315 0 4.5V6V7.5V19.5C0 21.1569 1.34315 22.5 3 22.5H21C22.6569 22.5 24 21.1569 24 19.5V7.5ZM1.5 19.5V7.5H22.5V19.5C22.5 20.3284 21.8284 21 21 21H3C2.17157 21 1.5 20.3284 1.5 19.5ZM4.5 10.5H9V18H4.5V10.5ZM3 10.5C3 9.67157 3.67157 9 4.5 9H9C9.82843 9 10.5 9.67157 10.5 10.5V18C10.5 18.8284 9.82843 19.5 9 19.5H4.5C3.67157 19.5 3 18.8284 3 18V10.5ZM12.75 10.5C12.3358 10.5 12 10.8358 12 11.25C12 11.6642 12.3358 12 12.75 12H18.75C19.1642 12 19.5 11.6642 19.5 11.25C19.5 10.8358 19.1642 10.5 18.75 10.5H12.75ZM12 14.25C12 13.8358 12.3358 13.5 12.75 13.5H18.75C19.1642 13.5 19.5 13.8358 19.5 14.25C19.5 14.6642 19.1642 15 18.75 15H12.75C12.3358 15 12 14.6642 12 14.25ZM12.75 16.5C12.3358 16.5 12 16.8358 12 17.25C12 17.6642 12.3358 18 12.75 18H15.75C16.1642 18 16.5 17.6642 16.5 17.25C16.5 16.8358 16.1642 16.5 15.75 16.5H12.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortalPageTemplate);
export default __webpack_public_path__ + "static/media/portal-page-template.e2bd2d98947f6b0917f7094ce6ba6df2.svg";
export { ForwardRef as ReactComponent };